<div class="pt-2 pb-3">
  <section class="mt-1 mb-3 rounded m-auto w-100" id="section" >
    <form [formGroup]="videoEditForm">

      <mat-form-field appearance="outline" class="w-100">
        <mat-label>{{'pass.name' | translate}}</mat-label>
        <input formControlName="name" type="text" matInput placeholder="{{'pass.name' | translate}}" data-nar="video-widget-name">
      </mat-form-field>

      <mat-form-field appearance="outline" class="w-100">
        <mat-label>{{'pass.layout' | translate}}</mat-label>
        <mat-select formControlName="layout">
          @for (lay of layoutTypes; track trackByLayout($index, lay)) {
            <mat-option value="{{lay.value}}" [attr.aria-label]="lay.translate" [disabled]="translationModeOriginal || data.translateMode">
              {{lay.translate | translate}}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-card class="mb-4">
        <mat-card-content>
          <div class="p-2">
            @if (url || urlData) {
              <div >
                <div class="d-flex align-items-center mb-3">
                  <mat-icon class="material-symbols-outlined">slideshow</mat-icon>
                  <span class="px-2">{{'pass.widgets.video' | translate}}</span>
                </div>
                <div class="d-flex justify-content-stretch flex-column">
                  @if (!url) {
                    <video crossorigin="anonymous" [vgMedia]="$any(media)" #media id="singleVideoV" preload="auto" controls width="100%"  class="me-2" style="max-height:300px;" (loadedmetadata)="onVideoMetadataVideo($event)">
                      <source [src]="urlData" type="video/mp4">
                    </video>
                  }
                  @if (url && urlData) {
                    <video crossorigin="anonymous" [vgMedia]="$any(media)" #media id="singleVideoV" preload="auto" controls width="100%"  class="me-2" style="max-height:300px;" (loadedmetadata)="onVideoMetadataVideo($event)">
                      <source [src]="urlData" type="video/mp4">
                    </video>
                  }
                  @if (url && !urlData) {
                    <video crossorigin="anonymous" [vgMedia]="$any(media)" #media id="singleVideoV" preload="auto" controls width="100%" class="me-2" style="max-height:300px;" (loadedmetadata)="onVideoMetadataVideo($event)">
                      <source [src]="url" type="video/mp4">
                    </video>
                  }
                  <div class="form-fields mt-4">
                    <div class="d-flex align-items-start">
                      <mat-form-field appearance="outline" class="flex-grow-1">
                        <mat-icon matIconPrefix class="material-symbols-outlined">link</mat-icon>
                        <mat-label>{{ 'pass.url' | translate }}</mat-label>
                        <input type="text" formControlName="url" matInput (blur)="checkNewUrl()" data-nar="video-widget-video-source">
                        @if (videoEditForm.controls['url']?.hasError('invalidCharacters')) {
                          <mat-error>
                            {{ 'invalid_characters' | translate }}
                          </mat-error>
                        }
                        @if (videoEditForm.controls['url']?.hasError('pattern') && !videoEditForm.controls['url']?.hasError('invalidCharacters')) {
                          <mat-error>
                            {{ 'url_pattern_invalid' | translate }}
                          </mat-error>
                        }
                        <button mat-icon-button matSuffix (click)="delete()" class="delete-button" matTooltip="{{ 'pass.deleteVideo' | translate }}" [disabled]="translationModeOriginal">
                          <mat-icon class="material-symbols-outlined">delete</mat-icon>
                        </button>
                      </mat-form-field>
                    </div>
                  </div>
                </div>
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>{{'pass.altTitle' | translate}}</mat-label>
                  <input formControlName="altTitle" type="text" matInput placeholder="{{'pass.altTitle' | translate}}" data-nar="video-widget-alt">
                </mat-form-field>
                @if (userHasBetaWidgetRole) {
                  <mat-expansion-panel>
                    <mat-expansion-panel-header>
                      <mat-panel-title style="color:#595c5f;">
                        <mat-icon style="margin-right: 10px;">image</mat-icon>
                        {{'pass.videoThumbnail' | translate}}
                        <span class="badge custom-badge rounded-pill ms-2">Beta</span>
                      </mat-panel-title>
                    </mat-expansion-panel-header>
                    <canvas #canvasElement style="display:none;"></canvas>
                    @if (thumbnailUrl) {
                      <div>
                        <img [src]="thumbnailUrl" style="width: 100%; margin-top: 10px;" />
                      </div>}
                      <button mat-button matTooltip="{{'pass.video.captureFrameHint' | translate}}" (click)="updateFrame()" class="secondary-gray-button my-3" [disabled]="translationModeOriginal || data.translateMode">
                        <mat-icon class="material-symbols-outlined">capture</mat-icon> {{'pass.video.captureFrame' | translate}}
                      </button>
                    </mat-expansion-panel>
                  }
                </div>
              }

              @if (!hasAnyVideo) {
                <div>
                  <div class="d-flex align-items-center mb-3">
                    <mat-icon class="material-symbols-outlined">slideshow</mat-icon>
                    <span class="px-2">{{'pass.widgets.video' | translate}}</span>
                  </div>
                  <div [app-drag-file-browse-ui]="dragFileData" (returnChanges)="returnChangesDragFileBrowseUI($event)"></div>
                </div>
              }
            </div>
          </mat-card-content>
        </mat-card>

        <mat-form-field appearance="outline" class="w-100">
          <mat-label>{{'pass.copyright' | translate}}</mat-label>
          <input formControlName="copyright" type="text" matInput placeholder="{{'pass.copyright' | translate}}" data-nar="video-widget-copyright">
        </mat-form-field>

        @if(layoutSelected === 'standard' ){
          <div class="d-flex flex-row">
            <div class="pe-2 flex-grow-1">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>{{'pass.title' | translate}}</mat-label>
                <input formControlName="title" type="text" matInput placeholder="{{'pass.title' | translate}}" data-nar="video-widget-title">
              </mat-form-field>
            </div>
            <div class="ps-2 flex-grow-1">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>{{'pass.subtitle' | translate}}</mat-label>
                <input formControlName="subtitle" type="text" matInput placeholder="{{'pass.subtitle' | translate}}" data-nar="video-widget-subtitle">
              </mat-form-field>
            </div>
          </div>
        }

        @if(layoutSelected == 'splash'){
          <div class="form-control p-3 mb-3 d-flex justify-content-between w-100">
            <div class="d-flex align-items-center">
              <span class="material-symbols-outlined me-2">unfold_more</span>
              <label>{{ 'pass.video.showMoreIndicator' | translate }}</label>
            </div>
            <mat-slide-toggle class="ms-5 example-margin" formControlName="showMoreIndicator"></mat-slide-toggle>
          </div>
        }

        <div class="form-control p-3 mb-3 d-flex justify-content-between w-100">
          <div class="d-flex align-items-center">
            <span class="material-symbols-outlined me-2">autoplay</span>
            <label>{{ 'pass.video.auto_play' | translate }}</label>
          </div>
          <mat-slide-toggle class="ms-5 example-margin" formControlName="autoPlay" data-nar="video-widget-autoplay"></mat-slide-toggle>
        </div>

        <div class="form-control p-3 mb-3 d-flex justify-content-between w-100">
          <div class="d-flex align-items-center">
            <span class="material-symbols-outlined me-2">repeat</span>
            <label>{{ 'pass.video.auto_replay' | translate }}</label>
          </div>
          <mat-slide-toggle class="ms-5 example-margin" formControlName="autoRePlay" data-nar="video-widget-autoreplay"></mat-slide-toggle>
        </div>

        <div class="form-control p-3 mb-3 d-flex justify-content-between w-100">
          <div class="d-flex align-items-center">
            <span class="material-symbols-outlined me-2">volume_off</span>
            <label>{{ 'pass.video.muted' | translate }}</label>
          </div>
          <mat-slide-toggle class="ms-5 example-margin" formControlName="muted" data-nar="video-widget-muted"></mat-slide-toggle>
        </div>

        <div class="form-control p-3 mb-3 d-flex justify-content-between w-100">
          <div class="d-flex align-items-center">
            <span class="material-symbols-outlined me-2">tune</span>
            <label>{{ 'pass.video.controls' | translate }}</label>
          </div>
          <mat-slide-toggle class="ms-5 example-margin" formControlName="videoControls" data-nar="video-widget-controls"></mat-slide-toggle>
        </div>

        @if(layoutSelected === 'standard'){
          <div [app-widget-styling] = "{'form': videoEditForm.value, 'widgetData': data}" (returnChanges)="returnChangesStyle($event)"></div>
        }

      </form>
    </section>
    <div [app-widget-edit-filters] = "{'form': videoEditForm.value, 'widgetData': data}" (returnChanges)="returnChangesFilters($event)"></div>
  </div>